export function decodeBase64(base64String: string): string {
    try {
        // Convert base64 to binary string
        const binaryString = atob(base64String);

        // Encode binary string to UTF-8
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }

        const decoder = new TextDecoder('utf-8');
        return decoder.decode(bytes);
    } catch (error) {
        throw new Error(`Invalid base64 string: ${error.message}`);
    }
}

export function decodeJwtPayload(token: string): Record<string, any> {
    try {
        const parts = token.split('.');
        if (parts.length !== 3) {
            throw new Error('JWT must have 3 parts separated by dots');
        }

        // Decode the payload (second part)
        const payload = decodeBase64(parts[1]);
        return JSON.parse(payload);
    } catch (error) {
        throw new Error(`Failed to decode JWT: ${error.message}`);
    }
}
